import { updateUsers, Users } from '@/entities/users';
import { Api } from './api/axios-config';

export class UserService{
  private static api = Api();

  public static async getAllUsers(){
    const response = await this.api.get<any>('users');  
    if(response.status === 200){
      return response.data;
    }
  }

  public static async getUserById(id:number){
    const response = await this.api.get<any>(`userId/${id}`);
    if(response.status === 200){
      return response.data;
    }
  }

  public static async deleteUser(id:number) {
    const response = await this.api.delete(`user/${id}`);
    return response
  }

  public static async updateUser(id:number, user: updateUsers){
    const response = await this.api.patch(`user/${id}`, {
      name: user.name,
      email: user.email,
      companyId: user.companyId,
      roleId: user.roleId,
    });
    if(response.status === 201) {
      return response;
    }
  }

  public static async updateColaboratorIdByEmail(colaboratorId: number, email: string) {
    try {const response = await this.api.post(`update-colaborator`, {
      colaboratorId: colaboratorId,
      email: email,
    })
    if(response.status ===201) {
      return response;
    }} catch (e){
      console.error(e);
    }
  }
}
